import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { default as TouchBackend } from 'react-dnd-touch-backend';
import SegmentLoader from 'common/components/SegmentLoader';
import ZoneImage from './ZoneImage';
import NoZoneImage from './NoZoneImage';
import { getIsFetching, getZone } from '../reducers/zone';
import { getPinnedPoints, getDisplayedPoint } from '../reducers/points';
import { fetchZone } from '../actions/zone';
import { displayPoint } from '../actions/points';
import PointDragLayer from './PointDragLayer';
import EditPointModal from './EditPointModal';
import mobilecheck from 'utils/mobilecheck';

const mapStateToProps = state => ({
  isFetching: getIsFetching(state),
  zone: getZone(state),
  pinnedPoints: getPinnedPoints(state),
  displayedPoint: getDisplayedPoint(state),
});

const renderZoneImage = (zone, points, placePoint, displayPoint) => {
  if (zone.image) {
    return (
      <div className="ui segment zone" style={{ touchAction: 'manipulation' }}>
        <ZoneImage
          zone={zone}
          points={points}
          onPlacePoint={placePoint}
          onDisplayPoint={displayPoint}
        />
      </div>
    );
  }

  return <NoZoneImage />;
};

class App extends Component {
  componentDidMount() {
    const { id, fetchZone } = this.props;

    fetchZone(id);
  }

  render() {
    const {
      disabled,
      isFetching,
      zone,
      pinnedPoints,
      displayedPoint,
      placePoint,
      displayPoint,
      hidePoint,
      savePoint,
      deletePoint,
    } = this.props;

    if (isFetching || !zone) {
      return <SegmentLoader />;
    }

    const controlledPlacePoint = disabled ? () => {} : placePoint;

    return (
      <div className="ui grid">
        <div className="eleven wide column">
          {renderZoneImage(
            zone,
            pinnedPoints,
            controlledPlacePoint,
            displayPoint
          )}
        </div>
        <PointDragLayer taskType={zone.task_type} />
        {displayedPoint && (
          <EditPointModal
            point={displayedPoint}
            onClose={hidePoint}
            onSave={savePoint}
            onDelete={deletePoint}
            disabled={disabled}
          />
        )}
      </div>
    );
  }
}

App.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  fetchZone: PropTypes.func.isRequired,
  zone: PropTypes.object,
  pinnedPoints: PropTypes.array.isRequired,
  displayedPoint: PropTypes.object,
  displayPoint: PropTypes.func.isRequired,
};

const PreparedBackend = () => {
  const isMobile = mobilecheck();
  if (isMobile) {
    return TouchBackend;
  } else {
    return HTML5Backend;
  }
};

export default DragDropContext(PreparedBackend())(
  connect(mapStateToProps, {
    fetchZone,
    displayPoint,
  })(App)
);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/components/App.js